import Store from "../store";

const HasService = function () {
  return Object.keys(Store.getters["service/available"]).length === 0 &&
    Store.getters["service/available"].constructor === Object
    ? false
    : true;
};

export const View = function (view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
};

export const NavGuard = function (to, from, next) {
  if (HasService()) next();
  else next({ path: "/" });
};
